import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ColorScale from '_class/ColorScale';
import { translate } from '@haldor/ui';
import '../../Verdict.scss';
var VerdictDisplayLevel = /*#__PURE__*/function (_Component) {
  function VerdictDisplayLevel() {
    _classCallCheck(this, VerdictDisplayLevel);
    return _callSuper(this, VerdictDisplayLevel, arguments);
  }
  _inherits(VerdictDisplayLevel, _Component);
  return _createClass(VerdictDisplayLevel, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (this.props.scale == null) {
        return null;
      }
      var translate = this.props.translate;
      var colors = new ColorScale(this.props.scale.levels.length).get();
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-level-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "verdict-cells"
      }, this.props.scale.levels.map(function (cell, index) {
        var styles = {};
        if (_this.props.verdict != null) {
          if (cell.id == _this.props.verdict.scaleLevelId) {
            styles = {
              backgroundColor: cell.colorCode != null ? cell.colorCode : colors[cell.level],
              color: 'white'
            };
          }
        }
        return /*#__PURE__*/React.createElement("div", {
          key: 'verdict-cell-display-' + cell.id,
          style: styles,
          className: "cell"
        }, cell.localizationText != null ? cell.localizationText : cell.level);
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(VerdictDisplayLevel);